export default __webpack_public_path__ + "static/media/jp.5ca780fa.svg";